import { useState, useEffect } from "react";
import useErrorHandle from "../../../constant/errorHandling/useErrorHandle";
import { getTextColor } from "../../../utiles/helpers";
import { disableModuleAPI, enableModuleAPI } from "../../../services/apiServices";
import useShowAlert from "../../../utiles/AlertUtiles";

function AllModules({ isStore, data = [], storeModules = [], onModule }) {
  const [moduleList, setModuleList] = useState([]);
  const handleError = useErrorHandle();
  const showAlert=useShowAlert();

  useEffect(() => {
    const storeMap = storeModules?.reduce((acc, item) => {
      acc[item?.moduleKey] = item;
      return acc;
    }, {});

    const merged = data.map((mod) => {
      const storeMod = storeMap[mod.key];
      return {
        ...mod,
        status: storeMod?.status === "ACTIVE" ? "ACTIVE" : "INACTIVE",
        _id: storeMod?._id || null, // needed for disabling
      };
    });

    setModuleList(merged);
  }, [data, storeModules]);

  const handleToggle = async (index) => {
    console.log(...moduleList)
    const updated = [...moduleList];
    const item = updated[index];
    console.log("items",item)

    try {
      if (item?.status === "INACTIVE") {

        await enableModuleAPI({
          mainstoreid: isStore?._id,
          moduleKey: item?.key,
        });
        updated[index].status = "ACTIVE";
      } else {
        if (!item?._id) {
            showAlert("This module cannot be disabled as it's not linked to the store.");
        }
        await disableModuleAPI({
          mainstoreid: isStore?._id,
          moduleid: item?._id,
        });
        updated[index].status = "INACTIVE";
      }

      setModuleList(updated);
    //   onModule && onModule(updated);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3">
                <span className={getTextColor(isStore?.stype)}>
                  Modules List
                </span>
              </h5>

              {moduleList?.map((item, index) => (
                <div
                  key={item?.id}
                  className="d-flex justify-content-between align-items-center py-2 border-bottom"
                >
                  <span className="text-secondary">{item?.label}</span>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={item?.status === "ACTIVE"}
                      onChange={() => handleToggle(index)}
                    />
                    <label className="ms-2 small text-uppercase fw-bold">
                      {item?.status}
                    </label>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllModules;
